var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: _vm.backgroundClass, attrs: { "data-arena-wrapper": "" } },
    [
      _c(
        "div",
        { staticClass: "text-center mt-4 pt-2" },
        [
          _vm.title !== null
            ? _c(
                "h2",
                { staticClass: "mb-4" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.title))]),
                  _vm._t("socket-status", function () {
                    return [
                      _c(
                        "sup",
                        {
                          staticClass: "socket-status-error",
                          attrs: { title: "WebSocket" },
                        },
                        [_vm._v("✗")]
                      ),
                    ]
                  }),
                  _vm._t("edit-button"),
                ],
                2
              )
            : _vm._e(),
          _vm._t("clock", function () {
            return [_c("div", { staticClass: "clock" }, [_vm._v("∞")])]
          }),
        ],
        2
      ),
      _c(
        "ul",
        { staticClass: "nav justify-content-center nav-tabs mt-4" },
        _vm._l(_vm.availableTabs, function (tab) {
          return _c(
            "li",
            {
              key: tab.name,
              staticClass: "nav-item",
              attrs: { role: "tablist" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.selectedTab === tab.name },
                  attrs: {
                    href: `#${tab.name}`,
                    "data-toggle": "tab",
                    role: "tab",
                    "aria-controls": tab.name,
                    "aria-selected": _vm.selectedTab === tab.name,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onTabSelected(tab.name)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(tab.text) + " "),
                  tab.name === "clarifications" && _vm.clarifications.length
                    ? _c(
                        "span",
                        { class: { unread: _vm.unreadClarifications } },
                        [_vm._v("(" + _vm._s(_vm.clarifications.length) + ")")]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "tab-content" }, [
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            class: { "show active": _vm.selectedTab === "problems" },
          },
          [_vm._t("arena-problems")],
          2
        ),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            class: { "show active": _vm.selectedTab === "ranking" },
          },
          [_vm._t("arena-scoreboard")],
          2
        ),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            class: { "show active": _vm.selectedTab === "runs" },
          },
          [_vm._t("arena-runs")],
          2
        ),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            class: { "show active": _vm.selectedTab === "clarifications" },
          },
          [_vm._t("arena-clarifications")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }